// src/services/api.js
// Point d'entrée unique pour l'URL de l'API backend. Toute autre partie du
// code (services, pages, composants) doit importer API_HOST / api depuis ce
// fichier plutôt que de relire process.env.VUE_APP_API_HOST directement.
import axios from 'axios';

export const API_HOST = process.env.VUE_APP_API_HOST;
export const API_URL = `${API_HOST}/api`;

const api = axios.create({ baseURL: API_URL });

// Routes publiques : ne jamais y attacher un token existant (potentiellement
// périmé), au risque de faire échouer l'appel côté backend si celui-ci
// valide le header Authorization même sur ces endpoints.
const PUBLIC_ENDPOINTS = ['/users/login', '/users/register', '/users/forgot-password', '/users/reset-password'];

api.interceptors.request.use(
    (config) => {
        const isPublicEndpoint = PUBLIC_ENDPOINTS.some((endpoint) => config.url?.startsWith(endpoint));
        const token = localStorage.getItem('token');
        if (token && !isPublicEndpoint) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default api;
